import {
    Flex,
    Image,
    TabPanel, Text, VStack,
} from '@chakra-ui/react';
import { ComponentProps, useEffect } from 'react';
import {
    NonIdealState, Pagination, usePaginationLabel,
} from '@acp/core-ui';
import { brandIcons } from '@acp/core-ui/assets';
import { NewManagementRow, NewManagementRowSkeleton } from './new-management-row';
import { useNewManagements } from '../../../integrated-portfolio';

export function NewManagementsTab({
    propertyManagerId,
    ...props
}: {
    propertyManagerId?: string;
} & ComponentProps<typeof TabPanel>) {
    const paginationProps = usePaginationLabel({
        defaultPage: 1,
        pageSize: 10,
    });

    const newManagementsQuery = useNewManagements(paginationProps.currentPage);

    useEffect(() => {
        if (newManagementsQuery.data === undefined) return;

        paginationProps.setTotalResults(newManagementsQuery.data.total);
    }, [newManagementsQuery.data]);

    return (
        <TabPanel as={VStack} alignItems="stretch" p={0} pt={2} gap={4} {...props}>
            {
                paginationProps.totalResults !== null && paginationProps.totalResults > 0 && (
                    <Flex alignItems={['start', null, null, 'center']} flexDir={['column', null, null, 'row']} gap={4}>
                        <Text flexGrow={1}>
                            Arrange compliance checks for new managed properties.
                        </Text>
                        <Pagination {...paginationProps} />
                    </Flex>
                )
            }
            <VStack alignItems="center" justifyContent="center" gap={4}>
                {
                    (
                        !newManagementsQuery.isLoading
                        && newManagementsQuery.data !== undefined
                    )
                    && newManagementsQuery.data.items.map((newManagement) => (
                        <NewManagementRow
                            key={newManagement.portfolioPropertyId}
                            agencyPortfolioProperty={newManagement}
                        />
                    ))
                }
                {
                    (
                        !newManagementsQuery.isLoading
                        && newManagementsQuery.data !== undefined
                        && newManagementsQuery.data.items.length === 0
                    )
                    && (
                        <NonIdealState
                            iconComponent={<Image src={brandIcons.newManagement} />}
                            title="No new managements"
                            description="You are all up to date!"
                            py={24}
                        />
                    )
                }
                {
                    newManagementsQuery.isLoading
                        && Array.from({ length: 10 }).map((_, index) => (
                            // eslint-disable-next-line react/no-array-index-key
                            <NewManagementRowSkeleton key={index} />
                        ))
                }
            </VStack>
        </TabPanel>
    );
}
